import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export const updateCommentBadges = createAction(`${actionTypePrefix}/UPDATE_COMMENT_BADGES`, (comment, allBadges)=>({
        comment,
        allBadges
    }));
export const likeComment = createAction(`${actionTypePrefix}/LIKE`, (comment)=>({
        comment
    }));
export const unlikeComment = createAction(`${actionTypePrefix}/UNLIKE`, (comment)=>({
        comment
    }));
export const reportComment = createAction(`${actionTypePrefix}/REPORT`, (comment)=>({
        comment
    }));
export const featureComment = createAction(`${actionTypePrefix}/FEATURE`, (comment)=>({
        comment
    }));
export const unfeatureComment = createAction(`${actionTypePrefix}/UNFEATURE`, (comment)=>({
        comment
    }));
export const hideComment = createAction(`${actionTypePrefix}/HIDE`, (comment, insideModal)=>({
        comment,
        insideModal
    }));
export const unhideComment = createAction(`${actionTypePrefix}/UNHIDE`, (comment)=>({
        comment
    }));
export const requestSuccess = createAction(`${actionTypePrefix}/SUCCESS`, (actionType, comment)=>({
        isBusy: false,
        comment,
        actionType
    }));
export const requestFailure = createAction(`${actionTypePrefix}/FAILURE`, (actionType, comment, error)=>({
        comment,
        error,
        actionType
    }));
export const reduxModuleLoaded = createAction(`${actionTypePrefix}/REDUX_MODULE_LOADED`, ()=>({}));
